import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody, TextHero } from '@tkww/orion-web-ds-text';

import { useAtomValue } from 'jotai';
import React, { type CSSProperties } from 'react';
import { scrollbarWidthAtom } from '../../../../jotai/shared/scrollbar-width';
import Styles from './styles.scss';

const WhyUseKnotFullWidth = () => {
	const scrollbarWidth = useAtomValue(scrollbarWidthAtom);
	return (
		<div className={Styles.parentContainer}>
			<div
				className={Styles.backgroundFullWidth}
				style={
					{
						'--scrollbar-width': `${scrollbarWidth}px`,
					} as CSSProperties
				}
			/>
			<TextBody size="md" className={Styles.content}>
				<TextHero as="h2">Why use The Knot to message vendors?</TextHero>
				<ul>
					<li>
						<Icon name="check-expressive" size="sm" aria-label="Check" />
						<span>
							Messaging our verified vendors on The Knot is free, safe and
							secure.
						</span>
					</li>
					<li>
						<Icon name="check-expressive" size="sm" aria-label="Check" />
						<span>
							Conveniently track vendor messages and planning details all in one
							place.
						</span>
					</li>
					<li>
						<Icon name="check-expressive" size="sm" aria-label="Check" />
						<span>
							Our mobile apps make it easy to stay in touch with vendors while
							you're on‑the‑go.
						</span>
					</li>
					<li>
						<Icon name="check-expressive" size="sm" aria-label="Check" />
						<span>
							For personalized pricing and package details, sending the vendor a
							message is the fastest way to get info.
						</span>
					</li>
				</ul>
			</TextBody>
		</div>
	);
};
export default WhyUseKnotFullWidth;
